<!-- eslint-disable -->
<template lang="pug">
    router-link.user(
        v-if="canLinkToUser(displayedUser)"
        :to="{name: 'user:profile', params: {id: displayedUser.id, type: displayedUser.type}}"
    )
        img.user__avatar(
            v-if="withAvatar"
            :src="displayedUser.avatar"
        )
        .user__info
            .user__type(v-if="profileType") {{ profileType }}
            .user__name {{ displayedUser.firstName }} {{ displayedUser.lastName }}
            slot(v-if="$slots['info']" name="info")
    .user(v-else)
        img.user__avatar(
            v-if="withAvatar"
            :src="displayedUser.avatar"
        )
        .user__info
            .user__type(v-if="profileType") {{ profileType }}
            .user__name {{ displayedUser.firstName }} {{ displayedUser.lastName }}
            slot(v-if="$slots['info']" name="info")
</template>

<script>
    /*eslint-disable*/
    import usersListMixin from "../../../utils/user/usersListMixin"

    export default {
        props: {
            displayedUser: {
                type: Object,
                default: null
            },
            profileType: {
                type: String,
                default: ''
            },
            withAvatar: {
                type: Boolean,
                default: true
            }
        },
        mixins: [usersListMixin]
    }
</script>

<style lang="scss" scoped>
    .user {
        display: flex;
        align-items: center;
    }

    .user__avatar {
        border-radius: 50%;
        max-height: none;
        height: 60px;
        width: 60px;
        margin-right: 12px;
    }

    .user__name {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .user__type {
        color: $x-color-black;
        text-decoration: none;
        font-weight: 500;
        margin-bottom: 8px;
    }
</style>
